// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__DCjB-","screen":"style_screen__Ta7ZM","File":"style_File__-29kC","Changes":"style_Changes__czeRL","Add":"style_Add__Nn20C"};